import Vue from "vue";
import Vuex from "vuex";
import i18n from "../i18n";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });
import btrz from "../api/betterez.inventory.api.js";
import btrzAccounts from "../api/betterez.accounts.api";
import btrzSales from "../api/betterez.sales.api.js";
import btrzPayments from "../api/betterez.btrz-pay.api";
import btrzNotifications from "../api/betterez.notifications.api";
import { excludessrs } from './ssrs-exclude.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Base information
    providerId: process.env.VUE_APP_BETTEREZ_PROVIDER_ID,
    lexicons: [],
    // Product Select
    products: [],
    current_product: Object,
    other_products: [],
    // Fares
    fares: [],
    selectedFaresStore: Object,
    fareString: "",
    // Trip Type Select
    tripType: "oneway",
    // From Select
    origins: [],
    origin: Object,
    originId: "from",
    // To Select
    destinations: [],
    destination: Object,
    destinationId: "to",
    // Dates
    departure: "",
    return: "",
    // Operation Messages
    operationMessages: [],
    // Trips
    isDeepLinkLoading: false,
    trips: [],
    // Selected Trip Info
    fareClassId: "",
    departureFareClass: "",
    departureTripId: "",
    departureTripItem: "",
    tripId: "",
    returnFareClass: "",
    returnTripId: "",
    returnTripItem: "",
    // Seat Maps
    seatMaps: "",
    departureSeatMap: "",
    returnSeatMap: "",
    seatMapActivePassenger: 0,
    passengerSeats: [],
    // Special Service Requests
    ssrs: [],
    boolssrs: [],
    qtyssrs: [],
    // Passengers
    passengers: [],
    // Cart information
    cart: Object,
    cartTrips: [],
    countries: [],
    paymentMethods: [],
    // Payment Information
    paymentInfo: {},
    gcAvailable: "",
    vcAvailable: "",
    payments: [],
    // Customer Information
    customerInfo: {},
    customFields: [],
  },
  getters: {
    getLexiconTranslation: (state) => (lexiconKey) => {
      let lexiconItem = state.lexicons.find(
        (lexicon) => lexicon.key === lexiconKey
      );
      return i18n.locale == "en"
        ? lexiconItem.values["en-us"]
        : lexiconItem.values["fr-fr"];
    },
    requiresCompanion: (state) => {
      let fares = state.fares;
      let fareCompanions = [];
      for (const [fare, count] of Object.entries(state.selectedFaresStore)) {
        if (count > 0) {
          const currentType = fares.filter(function (currentFare) {
            return currentFare._id == fare;
          });
          fareCompanions.push(currentType[0].requiresCompanion);
        }
      }
      if (fareCompanions.indexOf(true) > -1) {
        if (fareCompanions.indexOf(false) > -1) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    currentPassengerString: (state, getters) => {
      //var fareDetails = state.fares;
      var passengerArray = [];
      for (const [key, value] of Object.entries(state.selectedFaresStore)) {
        if (value > 0) {
          const currentType = state.fares.filter(function (fare) {
            return fare._id == key;
          });
          passengerArray.push(
            value +
            " " +
            getters.getLexiconTranslation(currentType[0].lexiconKeys.name)
          );
        }
      }
      return passengerArray.join(", ");
    },
    currentFareString: (state) => {
      const fareSelections = Object.entries(state.selectedFaresStore);
      let faresArray = [];
      for (const [fare, count] of fareSelections) {
        if (count > 0) {
          faresArray.push(fare + ":" + count);
        }
      }
      return faresArray.join(",");
    },
    getBoolSSRS: (state) => {
      return state.ssrs.filter(function (ssr) {
        return ssr.type === "value" && (! (ssr.code in excludessrs ));
      });
    },
    getQtySSRS: (state) => {
      return state.ssrs.filter(function (ssr) {
        return ssr.type === "quantity" && (! (ssr.code in excludessrs ));
      });
    },
    getMultiSSRS: (state) => {
      return state.ssrs.filter(function (ssr) {
        return ssr.type === "multivalue" && (! (ssr.code in excludessrs ));
      });
    },
    currentPassengerSeats: (state) => (passengerIndex) => {
      return state.passengers[passengerIndex].seats;
    },
    stateSelectedSeats: (state) => {
      //let stateSelectedSeats = state.passengers.map((p) => p.seats).flat();
      return state.passengers.map((p) => p.seats).flat();
    },
    cartBalance: (state) => {
      let paymentValues = state.payments
        .map((item) => Number(item.formattedBalance))
        .reduce((prev, next) => prev + next, 0);
      let totalPayment = isNaN(paymentValues) ? 0 : paymentValues;
      let cartTotal = Number(state.cart.total).toFixed(2);
      return (cartTotal - totalPayment).toFixed(2);
    },
    cartTotal: (state) => {
      return Number(state.cart.total).toFixed(2);
    },
    getPayments: (state) => {
      let payments = state.payments;
      let paymentPost = [];
      let cartBalance = state.cart.total;
      // if (state.paymentInfo) {
      //   payments.push(state.paymentInfo);
      // }
      var paymentAmount = 0;
      payments.forEach(function (payment) {
        if (payment.internalId) {
          if (cartBalance > payment.formattedBalance) {
            paymentAmount = payment.formattedBalance;
          } else if (cartBalance < payment.formattedBalance) {
            paymentAmount = cartBalance;
          }
          cartBalance = cartBalance - paymentAmount;
          paymentPost.push({
            method: "voucher",
            voucher: payment.internalId,
            amount: paymentAmount,
          });
        }
        if (payment.GCNumber) {
          if (cartBalance > payment.formattedBalance) {
            paymentAmount = payment.formattedBalance;
          } else if (cartBalance < payment.formattedBalance) {
            paymentAmount = cartBalance;
          }
          cartBalance = cartBalance - paymentAmount;
          paymentPost.push({
            method: "gift_certificate",
            voucher: payment.GCNumber,
            amount: paymentAmount,
          });
        }
        if (payment.paymentMethod === "online_credit") {
          paymentPost.push({
            method: payment.paymentMethod,
            amount: cartBalance,
            card: payment.cardType,
            description: "Order No " + state.cart.cartId,
            sec: payment.ccv,
            ccnumber: payment.ccnumber,
            expiryMonth: payment.expiryMonth,
            expiryYear: payment.expiryYear,
          });
        }
      });
      return paymentPost;
    },
  },
  mutations: {
    // Product Selection
    // getProducts(state) {
    //   btrz
    //     .getProducts()
    //     .then((response) => {
    //       return response.data.products;
    //     })
    //     .then((products) => {
    //       function compare(a, b) {
    //         if (a.ord < b.ord) {
    //           return -1;
    //         }
    //         if (a.ord > b.ord) {
    //           return 1;
    //         }
    //         return 0;
    //       }
    //       let sortedProducts = products.sort(compare);
    //       state.products = sortedProducts;
    //       state.current_product = sortedProducts[0];
    //       state.other_products = sortedProducts.filter(
    //         (product) => product._id != state.current_product._id
    //       );
    //     });
    // },
    SET_LEXICONS(state, lexicons) {
      state.lexicons = lexicons;
    },
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_CURRENT_PRODUCT(state, product) {
      state.current_product = product;
    },
    // Reset trips
    // resetFares(state) {
    //   state.fares = [];
    // },
    SET_FARES(state, fares) {
      state.fares = fares;
      // When fares are set, reset selections
      // state.selectedFaresStore = {};
      // state.fareString = "";
    },
    SET_SELECTED_FARES(state, selectedFares) {
      state.selectedFaresStore = selectedFares;
      let fareString = "";
      const fareSelections = Object.entries(selectedFares);
      for (const [fare, count] of fareSelections) {
        if (count > 0) {
          fareString = fareString + `${fare}:${count},`;
        }
      }
      fareString = fareString.substring(0, fareString.length - 1);
      state.fareString = fareString;
    },
    // Get Fares
    // getFares(state, productId) {
    //   btrz.getFares(productId).then((response) => {
    //     const allfares = response.data.fares;
    //     // Only show first 4 products
    //     const limitedFares = allfares.slice(0, 4);
    //     function compareValues(key, order = 'asc') {
    //       return function innerSort(a, b) {
    //         if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
    //           // property doesn't exist on either object
    //           return 0;
    //         }

    //         const varA =
    //           typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    //         const varB =
    //           typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    //         let comparison = 0;
    //         if (varA > varB) {
    //           comparison = 1;
    //         } else if (varA < varB) {
    //           comparison = -1;
    //         }
    //         return order === 'desc' ? comparison * -1 : comparison;
    //       };
    //     }
    //     state.fares = limitedFares.sort(compareValues('ord'));
    //   });
    // },
    // setCurrentProduct(state, currentId) {
    //   // Set current product
    //   state.current_product = state.products.filter(
    //     (product) => product._id == currentId
    //   )[0];
    //   // Set other products
    //   // state.other_products = state.products.filter(
    //   //   (product) => product._id != currentId
    //   // );
    //   // Reset From Stations
    //   btrz.getStations(currentId).then((response) => {
    //     state.originId = 'from';
    //     state.origins = response.data.stations;
    //   });
    //   // Reset Fares
    //   btrz.getFares(currentId).then((response) => {
    //     const allfares = response.data.fares;
    //     // Only show first 4 products
    //     const limitedFares = allfares.slice(0, 4);
    //     function compareValues(key, order = 'asc') {
    //       return function innerSort(a, b) {
    //         if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
    //           // property doesn't exist on either object
    //           return 0;
    //         }

    //         const varA =
    //           typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    //         const varB =
    //           typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    //         let comparison = 0;
    //         if (varA > varB) {
    //           comparison = 1;
    //         } else if (varA < varB) {
    //           comparison = -1;
    //         }
    //         return order === 'desc' ? comparison * -1 : comparison;
    //       };
    //     }
    //     state.fares = limitedFares.sort(compareValues('ord'));
    //   });
    // },
    // Trip Type Selection
    SET_TRIP_TYPE(state, tripType) {
      state.tripType = tripType;
    },
    // setTripType(state, tripType) {
    //   state.tripType = tripType;
    // },
    // From Select
    SET_ORIGIN_STATIONS(state, stations) {
      state.origins = stations;
    },
    getFromStations(state, productId) {
      btrz.getStations(productId).then((response) => {
        state.origins = response.data.stations;
      });
    },
    SET_ORIGIN_STATION(state, originId) {
      state.originId = originId;
    },
    setOriginStation(state, originId) {
      state.originId = originId;
      // Reset To Select and Load stations
      btrz
        .getDestinationStations(state.current_product._id, state.originId)
        .then((response) => {
          state.destinationId = "to";
          state.destinations = response.data.stations;
        });
    },
    // To Select
    SET_DESTINATION_STATION(state, destinationId) {
      state.destinationId = destinationId;
    },
    SET_DESTINATIONS(state, destinations) {
      state.destinations = destinations;
    },
    setDestinationStation(state, destinationId) {
      state.destinationId = destinationId;
    },
    // Set dates
    setDate(state, payload) {
      if (payload.name === "departure") {
        state.departure = payload.date;
      } else {
        state.return = payload.date;
      }
    },
    // Passanger selection
    getSelectedFares(state) {
      return state.selectedFaresStore;
    },
    setFares(state, selectedFares) {
      let faresArray = [];
      const fareSelections = Object.entries(selectedFares);
      for (const [fare, count] of fareSelections) {
        if (count > 0) {
          faresArray.push(fare + ":" + count);
        }
      }
      state.selectedFaresStore = selectedFares;
      state.fareString = faresArray.join(",");
    },
    SET_FARE_DEEP_LINK(state, fareString) {
      state.fareString = fareString;
      let individualFares = fareString.split(",");
      let deepLinkFareObject = {};
      individualFares.forEach(function (fare) {
        let fareSplit = fare.split(":");
        Vue.set(deepLinkFareObject, fareSplit[0], Number(fareSplit[1]));
      });
      state.selectedFaresStore = deepLinkFareObject;
    },
    // Reset trips
    resetTrips(state) {
      state.tripType = "oneway";
      state.departure = "";
      state.return = "";
      state.trips = [];
      state.departureTripId = "";
      state.returnTripId = "";
      state.departureFareClass = "";
      state.returnFareClass = "";
    },
    RESET_TRIP(state) {
      state.tripType = "oneway";
      state.departure = "";
      state.return = "";
      state.trips = [];
      state.passengers = [];
      state.passengerSeats = [];
      state.selectedFaresStore = {};
      state.departureTripId = "";
      state.departureTripItem = "";
      state.departureFareClass = "";
      state.returnTripId = "";
      state.returnTripItem = "";
      state.returnFareClass = "";
    },
    RESET_TRIP_SELECTIONS(state) {
      state.trips = [];
      state.passengerSeats = [];
      state.departureTripId = "";
      state.departureTripItem = "";
      state.departureFareClass = "";
      state.returnTripId = "";
      state.returnTripItem = "";
      state.returnFareClass = "";
    },
    // Find Trips
    SET_TRIPS(state, trips) {
      state.trips = trips;
    },
    SET_DEEP_LINK_LOADING(state, loading) {
      state.isDeepLinkLoading = loading;
    },
    getTrips(state, payload) {
      btrz
        .getTrips(
          payload.productId,
          payload.originId,
          payload.destinationId,
          payload.departure,
          payload.return,
          payload.fareString
        )
        .then((response) => {
          state.trips = response.data.trips;
        });
    },
    SET_OPERATION_MESSAGES(state, payload) {
      state.operationMessages = payload;
    },
    DISMISS_OPERATION_MESSAGE(state, payload) {
      state.operationMessages = state.operationMessages.filter((message) => {
        message._id != payload;
      });
    },
    CLEAR_OPERATION_MESSAGES(state){
      state.operationMessages = [];
    },
    // Select a trip
    setTrip(state, payload) {
      if (payload.tripdir === "departure") {
        state.departureFareClass = payload.selectedClassId;
        state.departureTripId = payload.tripId;
        state.departureTripItem = payload.tripItem;
      }
      if (payload.tripdir === "return") {
        state.returnFareClass = payload.selectedClassId;
        state.returnTripId = payload.tripId;
        state.returnTripItem = payload.tripItem;
      }
    },
    // Get Special Service Request Items
    getSSRS(state, productId) {
      return btrz.getSSRS(productId).then((response) => {
        state.ssrs = response.data.ssrs;
        let responseSSRS = [...response.data.ssrs];

        let quantitySSRS = responseSSRS.filter(function (el) {
          return el.type === "quantity";
        });

        let booleanSSRS = responseSSRS.filter(function (el) {
          return el.type === "value";
        });

        let multivalueSSRS = responseSSRS.filter(function (el) {
          return el.type === "multivalue"
        });
	
        state.boolssrs = booleanSSRS;
        state.qtyssrs = quantitySSRS;
        state.multissrs = multivalueSSRS;
      });
    },
    setPassenger(state, payload) {
      // Set passenger object by passenger index from passengersList
      state.passengers[payload.index] = payload.passengerObject;
    },
    getSeatMap(state) {
      btrz
        .getSeatMap(
          state.departureTripItem.segments[0].seatMapId,
          state.departureTripItem.segments[0].routeId,
          state.departureTripItem.segments[0].name,
          state.departureTripItem.segments[0].manifestDate,
          state.originId,
          state.destinationId,
          state.providerId,
          state.departureTripItem.segments[0].legFrom,
          state.departureTripItem.segments[0].legTo
        )
        .then((response) => {
          state.departureSeatMap = response.data.seatmap;
        });
    },
    getReturnSeatMap(state) {
      btrz
        .getSeatMap(
          state.returnTripItem.segments[0].seatMapId,
          state.returnTripItem.segments[0].routeId,
          state.returnTripItem.segments[0].name,
          state.returnTripItem.segments[0].manifestDate,
          state.destinationId,
          state.originId,
          state.providerId,
          state.returnTripItem.segments[0].legFrom,
          state.returnTripItem.segments[0].legTo
        )
        .then((response) => {
          state.returnSeatMap = response.data.seatmap;
        });
    },
    setSeatMapActivePassenger(state, passengerIndex) {
      state.seatMapActivePassenger = passengerIndex;
    },
    setPassengerSeat(state, payload) {
      function pushToArray(arr, obj) {
        const index = arr.findIndex((e) => e.id === obj.id);

        if (index === -1) {
          arr.push(obj);
        } else {
          Vue.set(arr, index, obj);
          //arr[index] = obj;
        }
      }
      pushToArray(state.passengerSeats, {
        id: payload.passenger,
        seat: payload.seat,
        row: payload.row,
        section: payload.section,
      });
      state.seatMapActivePassenger = 999;
    },
    REMOVE_SEAT_SELECTIONS(state) {
      // Clone item to keep it reactive.
      const updatedPassengers = [...state.passengers];
      updatedPassengers.forEach((passenger, index) => {
        updatedPassengers[index].seats = [];
      });
      this.passengers = updatedPassengers;
    },
    REMOVE_PASSENGER_SEAT(state, selection) {
      // Clone item to keep it reactive.
      const updatedPassengers = { ...state.passengers };
      let currentSelections = updatedPassengers[selection.passenger].seats;

      let newSelections = currentSelections.filter(function (seat) {
        return seat.tripId !== selection.tripId;
      });
      updatedPassengers[selection.passenger].seats = newSelections;
      this.passengers = updatedPassengers;
    },
    SET_PASSENGER_SEAT(state, selection) {
      function pushToArray(arr, obj) {
        const index = arr.findIndex((e) => e.tripId === obj.tripId);

        if (index === -1) {
          arr.push(obj);
        } else {
          Vue.set(arr, index, obj);
        }
      }
      // Mockup
      // pushToArray(state.passengerSeats, {
      //   id: selection.passenger,
      //   seat: selection.seat,
      //   row: selection.row,
      //   section: selection.section,
      //   tripId: selection.tripId,
      // });
      // Cart
      pushToArray(state.passengers[selection.passenger].seats, {
        seatMapId: selection.seatMapId,
        sectionId: selection.section._id,
        sectionName: selection.section.label,
        rowLabel: selection.row.label,
        seatNumber: selection.seat.label,
        seatId: selection.seat.id,
        scheduleId: selection.scheduleId,
        tripId: selection.tripId,
      });
    },
    EMPTY_CART(state) {
      state.cart = {};
      state.payments = [];
      state.paymentInfo = {};
      state.customerInfo = {};
      state.cartTrips = [];
      //state.order = {};
    },
    SET_CART_INFO(state, payload) {
      // Add Selected Trips to State when added to cart.
      if (state.departureTripItem) {
        state.cartTrips.push(state.departureTripItem);
      }
      if (state.returnTripItem) {
        state.cartTrips.push(state.returnTripItem);
      }
      return (state.cart = payload);
    },
    getCountries(state) {
      btrz.getCountries().then((response) => {
        function compare(a, b) {
          if (a.ord < b.ord) {
            return -1;
          }
          if (a.ord > b.ord) {
            return 1;
          }
          return 0;
        }
        let countries = response.data.countries;
        let sortedCountries = countries.sort(compare);
        state.countries = sortedCountries;
      });
    },
    getPaymentMethods(state) {
      btrzPayments.getPaymentMethods().then((response) => {
        function compare(a, b) {
          if (a.ord < b.ord) {
            return -1;
          }
          if (a.ord > b.ord) {
            return 1;
          }
          return 0;
        }
        let paymentMethods = response.data.paymentMethods;
        let sortedpaymentMethods = paymentMethods
          .sort(compare)
          .filter((paymentMethod) => paymentMethod.method !== "credit")
          .filter((paymentMethod) => paymentMethod.method !== "no_payment");
        state.paymentMethods = sortedpaymentMethods;
      });
    },
    setPaymentInfo(state, payload) {
      state.paymentInfo = payload;
    },
    setCustomerInfo(state, payload) {
      return (state.customerInfo = payload);
    },
    resetOrder(state) {
      state.order = {};
    },
    setOrderInfo(state, payload) {
      return (state.order = payload);
    },
    checkGC(state, payload) {
      btrzSales.checkGC(payload.cartId, payload.gcNumber).then((response) => {
        state.gcAvailable = response.data;
      });
    },
    checkVC(state, payload) {
      btrzSales.checkVC(payload.cartId, payload.internalId).then((response) => {
        state.vcAvailable = response.data;
      });
    },
    ADD_PAYMENT(state, payload) {
      function pushToArray(arr, obj) {
        const index = arr.findIndex((e) => e._id === obj._id);

        if (index === -1) {
          arr.push(obj);
        } else {
          Vue.set(arr, index, obj);
        }
      }

      pushToArray(state.payments, payload);
    },
    REMOVE_PAYMENT(state, payload) {
      state.payments = state.payments
        .filter((payment) => payment._id !== payload)
        .filter((payment) => payment.GCNumber !== payload);
    },
    GET_CUSTOM_FIELDS(state) {
      return btrzSales.getCustomFields().then((response) => {
        state.customFields = response.data.customFields;
      });
    },
    SET_CUSTOM_FIELDS(state, customFields) {
      state.customFields = customFields;
    },
    SEND_ORDER_EMAIL(state) {
      return btrzNotifications.sendOrderEmail(state.order.orderId, i18n.locale);
    },
  },
  actions: {
    getLexicons({ commit }) {
      return btrzAccounts.getLexicons().then((response) => {
        commit("SET_LEXICONS", response.data.lexicons);
      });
    },
    deepLinkForm({ commit, dispatch, state }, deepLinkQuery) {
      commit("SET_DEEP_LINK_LOADING", true);
      // Deep link test ON
      // ?productId=5d3f5143fdfa2714090019ea&from=568bdb5452af98762b005b3c&to=528cdd9b61c78c2f2d000053&departureDate=2023-11-28&type=oneway&fares=52fa96bbc5e9c64a0400001b:1
      dispatch("fetchProducts").then(() => {
        let current_product = state.products.filter((product) => {
          return product._id === deepLinkQuery.productId;
        });
        commit("SET_TRIP_TYPE", "oneway");
        commit("setDate", {
          name: "departure",
          date: deepLinkQuery.departureDate,
        });
        dispatch("changeProduct", current_product[0]).then(() => {
          dispatch("fetchFromStations").then(() => {
              commit("SET_ORIGIN_STATION", deepLinkQuery.from);
              commit("SET_DESTINATION_STATION", deepLinkQuery.to);
              dispatch("changeFromStation", deepLinkQuery.from).then(() => {
                commit("SET_DESTINATION_STATION", deepLinkQuery.to);
                dispatch("changeToStation", deepLinkQuery.to).then(() => {
                    dispatch("fetchFares").then(() => {
                      commit("SET_FARE_DEEP_LINK", deepLinkQuery.fares);
                      commit("SET_DEEP_LINK_LOADING", false);
                      location.replace("/");
                    });
                  });
              });   
          });
        });
      });
    },
    deepLinkTrips({ commit, dispatch, state }, deepLinkQuery) {
      commit("SET_DEEP_LINK_LOADING", true);
      // Deep link test ON
      // ?productId=5d3f5143fdfa2714090019ea&from=568bdb5452af98762b005b3c&to=528cdd9b61c78c2f2d000053&departureDate=2020-09-28&type=oneway&fares=52fa96bbc5e9c64a0400001b:1
      dispatch("fetchProducts").then(() => {
        let current_product = state.products.filter((product) => {
          return product._id === deepLinkQuery.productId;
        });
        commit("SET_TRIP_TYPE", deepLinkQuery.type);
        commit("setDate", {
          name: "departure",
          date: deepLinkQuery.departureDate,
        });
        if (deepLinkQuery.type == "roundtrip") {
          commit("setDate", {
            name: "return",
            date: deepLinkQuery.returnDate,
          });
        }
        dispatch("changeProduct", current_product[0]).then(() => {
          dispatch("fetchFromStations")
            .then(() => {
              commit("SET_ORIGIN_STATION", deepLinkQuery.from);
            })
            .then(() => {
              commit("SET_DESTINATION_STATION", deepLinkQuery.to);
              dispatch("fetchFares")
                .then(() => {
                  commit("SET_FARE_DEEP_LINK", deepLinkQuery.fares);
                  // dispatch('fetchTrips');
                }).then(()=>{
                  dispatch("fetchOperatingMessages").then(() => {
                    dispatch("fetchTrips").then(() => {
                      commit("SET_DEEP_LINK_LOADING", false);
                    });
                  });
                });
            });
        });
      });
    },
    fetchProducts({ commit, dispatch }) {
      return btrz
        .getProducts()
        .then((response) => {
          function compare(a, b) {
            if (a.ord < b.ord) {
              return -1;
            }
            if (a.ord > b.ord) {
              return 1;
            }
            return 0;
          }
          let sortedProducts = response.data.products.sort(compare);
          let currentProduct = sortedProducts[0];
          commit("SET_PRODUCTS", sortedProducts);
          commit("SET_CURRENT_PRODUCT", currentProduct);
        })
        .then(() => {
          dispatch("fetchFares");
          dispatch("fetchFromStations");
        });

      // .catch((error) => {
      //   // eslint-disable-next-line no-console
      //   console.log('There was an error fetching products:', error.response);
      // })
    },
    changeProduct({ commit, state }, product) {
      return new Promise((resolve) => {
        setTimeout(() => {
          commit("SET_CURRENT_PRODUCT", product);
          // When product is changed selected Fares should be reset.
          state.selectedFaresStore = {};
          resolve();
        }, 500);
      });
      //commit('SET_CURRENT_PRODUCT', product);
      // dispatch('fetchFares');
      // dispatch('fetchFromStations');
      // setTimeout(() => {
      //   dispatch('fetchFares');
      //   dispatch('fetchFromStations');
      // }, 500);
    },
    fetchFares({ commit, state }) {
      return btrz
        .getFares(state.current_product._id)
        .then((response) => {
          const allfares = response.data.fares;
          // Only show first 4 products
          //const limitedFares = allfares.slice(0, 4);
          function compareValues(key, order = "asc") {
            return function innerSort(a, b) {
              if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
              }

              const varA =
                typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
              const varB =
                typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

              let comparison = 0;
              if (varA > varB) {
                comparison = 1;
              } else if (varA < varB) {
                comparison = -1;
              }
              return order === "desc" ? comparison * -1 : comparison;
            };
          }
          commit("SET_FARES", allfares.sort(compareValues("ord")));
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log("There was an error fetching fares:", error.response);
        });
    },
    fetchFromStations({ commit, state }) {
      return btrz
        .getStations(state.current_product._id)
        .then((response) => {
          commit("SET_ORIGIN_STATION", "from");
          commit("SET_ORIGIN_STATIONS", response.data.stations);
          commit("SET_DESTINATION_STATION", "to");
          commit("SET_DESTINATIONS", []);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(
            "There was an error fetching from stations:",
            error.response
          );
        });
    },
    changeFromStation({ commit, state }, stationId) {
      commit("SET_ORIGIN_STATION", stationId);
      return btrz
        .getDestinationStations(state.current_product._id, state.originId)
        .then((response) => {
          commit("SET_DESTINATION_STATION", "to");
          commit("SET_DESTINATIONS", response.data.stations);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(
            "There was an error fetching destination stations:",
            error.response
          );
        });
    },
    changeToStation({ commit }, stationId) {
      commit("SET_DESTINATION_STATION", stationId);
    },
    modifyTripStations({ commit }, { originId, destinationId }) {
      commit("SET_ORIGIN_STATION", originId);
      commit("SET_DESTINATION_STATION", destinationId);
      commit("RESET_TRIP_SELECTIONS");
    },
    resetTrip({ commit }) {
      commit("RESET_TRIP");
    },
    fetchOperatingMessages({ commit, state }) {
      // providerId, stationId, dateFrom, dateTo){
      return btrz
        .getOperationMessages(
          process.env.VUE_APP_BETTEREZ_PROVIDER_ID,
          state.departure,
          state.return
        )
        .then((response) => {
          let operationMessages = response.data.filter((item) => {
            return (
              item.stationId == state.originId ||
              item.stationId == state.destinationId ||
              item.stationId == ""
            );
          });
          commit("SET_OPERATION_MESSAGES", operationMessages);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(
            "There was an error fetching operation messages:",
            error.response
          );
        });
    },
    dismissOperationMessage({ commit }, messageId) {
      commit("DISMISS_OPERATION_MESSAGE", messageId);
    },
    clearOperationMessages({ commit }){
      commit("CLEAR_OPERATION_MESSAGES");
    },
    fetchTrips({ commit, state }) {
      return btrz
        .getTrips(
          state.current_product._id,
          state.originId,
          state.destinationId,
          state.departure,
          state.return,
          state.fareString
        )
        .then((response) => {
          commit("SET_TRIPS", response.data.trips);
        });
    },
    selectSeat({ commit }, selection) {
      commit("SET_PASSENGER_SEAT", selection);
    },
    // eslint-disable-next-line no-unused-vars
    addToCartShowCart(context) {
      let cartPostBody = {
        items: {
          reservation: [
            {
              productId: context.state.current_product._id,
              from: {
                _id: context.state.originId,
              },
              to: {
                _id: context.state.destinationId,
              },
              selectedTrips: {
                departureTripId: context.state.departureTripId,
                returnTripId: context.state.returnTripId,
              },
              roundTrip: context.state.tripType === "roundtrip",
              dateFrom: context.state.departure,
              dateTo: context.state.return,
              passengers: context.state.passengers,
            },
          ],
        },
        //providerId: context.state.providerId,
        channel: "websales",
      };
      //context.commit('resetCart');
      if (context.state.cart.cartId) {
        return btrzSales
          .createItemCart(cartPostBody, context.state.cart.cartId)
          .then((response) => {
            context.commit("SET_CART_INFO", response.data);
            // Clear current trip selections after added to cart.
            context.commit("RESET_TRIP");
          });
      } else {
        return btrzSales.createCart(cartPostBody).then((response) => {
          context.commit("SET_CART_INFO", response.data);
          // Clear current trip selections after added to cart.
          context.commit("RESET_TRIP");
        });
      }
    },
    removeFromCart({ commit, state }, operationId) {
      return btrzSales
        .removeFromCart(state.cart.cartId, operationId)
        .then(() => {
          return btrzSales.getCart(state.cart.cartId).then((response) => {
            commit("SET_CART_INFO", response.data.cart);
          });
        });
    },
    checkVoucher(context, voucherCode) {
      return btrzSales
        .checkVC(context.state.cart.cartId, voucherCode)
        .then((response) => {
          context.commit("ADD_PAYMENT", response.data);
          return response;
        });
    },
    checkGiftCertificate(context, giftCertificate) {
      return btrzSales
        .checkGC(context.state.cart.cartId, giftCertificate)
        .then((response) => {
          context.commit("ADD_PAYMENT", response.data);
          return response;
        });
    },
    applyPromoCode({ commit, state }, promoCode) {
      return btrzSales
        .applyPromoCode(state.cart.cartId, promoCode.toUpperCase())
        .then((response) => {
          btrzSales.getCart(state.cart.cartId).then((response) => {
            commit("SET_CART_INFO", response.data.cart);
          });
          return response;
        });
    },
    removePayment(context, paymentId) {
      context.commit("REMOVE_PAYMENT", paymentId);
    },
    getCustomFields(context) {
      context.commit("GET_CUSTOM_FIELDS");
    },
    createOrderShowConfirmation({ commit, state }) {
      // eslint-disable-next-line
      //console.log("payments", this.state.payments);
      // eslint-disable-next-line
      //console.log("payments filtered empty",this.state.payments.filter((value) => Object.keys(value).length !== 0));
      var payments = state.payments.filter(
        (value) => Object.keys(value).length !== 0
      );

      let paymentPost = [];
      let cartBalance = +state.cart.total;
      if (Object.keys(state.paymentInfo).length !== 0) {
        payments.push(state.paymentInfo);
      }
      // eslint-disable-next-line
      //console.log("payments after payment info", payments);
      var paymentAmount = 0;
      payments.forEach(function (payment) {
        // eslint-disable-next-line
        //console.log("Order Payment Log", payment);
        if (payment.internalId) {
          let paymentBalance = +payment.formattedBalance;
          if (cartBalance > paymentBalance) {
            paymentAmount = paymentBalance;
          } else if (cartBalance < paymentBalance) {
            paymentAmount = cartBalance;
          }
          cartBalance = cartBalance - paymentAmount;
          paymentPost.push({
            method: "voucher",
            voucher: payment.internalId,
            firstName: {
              firstName: state.paymentInfo.firstName,
              lastName: state.paymentInfo.lastName,
            },
            amount: Number(paymentAmount).toFixed(2),
            acceptedCurrencyAmount: Number(paymentAmount).toFixed(2),
          });
        }
        if (payment.GCNumber) {
          let paymentBalance = +payment.formattedBalance;
          if (cartBalance > paymentBalance) {
            paymentAmount = paymentBalance;
          } else if (cartBalance < paymentBalance) {
            paymentAmount = cartBalance;
          }
          cartBalance = cartBalance - paymentAmount;
          paymentPost.push({
            method: "gift_certificate",
            authCode: payment.GCNumber,
            description: "Web Sale Purchase",
            amount: Number(paymentAmount).toFixed(2),
            acceptedCurrencyAmount: Number(paymentAmount).toFixed(2),
          });
        }
        if (payment.paymentMethod === "online_credit") {
          // eslint-disable-next-line
          //console.log("Order Payment Is CC");
          paymentPost.push({
            method: payment.paymentMethod,
            amount: Number(cartBalance).toFixed(2),
            acceptedCurrencyAmount: Number(cartBalance).toFixed(2),
            card: payment.cardType,
            description: "Order No " + state.cart.cartId,
            //authorization: payment.ccv,
            sec: payment.ccv,
            ccnumber: payment.ccnumber,
            expiryMonth: payment.expiryMonth,
            expiryYear: payment.expiryYear,
          });
        }
      });

      // Old cc only payment post:
      // [
      //   {
      //     method: this.state.paymentInfo.paymentMethod,
      //     amount: this.state.cart.total,
      //     card: this.state.paymentInfo.cardType,
      //     description: 'paying!',
      //     authorization: this.state.paymentInfo.ccv,
      //     ccnumber: this.state.paymentInfo.ccnumber,
      //     expiryMonth: this.state.paymentInfo.expiryMonth,
      //     expiryYear: this.state.paymentInfo.expiryYear,
      //   },
      // ]
      let orderPostBody = {
        cartId: state.cart.cartId,
        customFields: state.customFields,
        payments: paymentPost,
        customerInfo: {
          firstName: state.paymentInfo.firstName,
          lastName: state.paymentInfo.lastName,
          email: state.customerInfo.customerEmail,
          phone: state.customerInfo.customerPhone,
          phoneType: "other",
          street: state.paymentInfo.addressStreet,
          city: state.paymentInfo.addressCity,
          country: state.paymentInfo.countryName,
          countryId: state.paymentInfo.country,
          province: state.paymentInfo.addressProvince,
          zip: state.paymentInfo.addressPostalCode,
          emailSubscriptionOptIn: false,
        },
        channel: "websales",
      };
      // eslint-disable-next-line
      //console.log("Order Post Body", orderPostBody);
      // eslint-disable-next-line
      //console.log("Payments Body", paymentPost);
      commit("resetOrder");
      return btrzSales.createOrder(orderPostBody).then((response) => {
        commit("setOrderInfo", response.data);
        return response;
      });
    },
  },
  plugins: [
    createPersistedState({
      key: "onvuex",
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
